import { render, staticRenderFns } from "./admin-student-referrals.vue?vue&type=template&id=4421d302&scoped=true"
import script from "./admin-student-referrals.vue?vue&type=script&lang=js"
export * from "./admin-student-referrals.vue?vue&type=script&lang=js"
import style0 from "./admin-student-referrals.vue?vue&type=style&index=0&id=4421d302&prod&lang=scss"
import style1 from "./admin-student-referrals.vue?vue&type=style&index=1&id=4421d302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4421d302",
  null
  
)

export default component.exports